import { ArrowRight, ChevronRightIcon, Shield } from 'lucide-react';
import * as React from 'react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { TypographyMuted } from '@/components/ui/typography';

import { FeatureCarousel } from './feature-carousel/feature-carousel';

export function SectionHero() {
  return (
    <section className="redesign-container">
      <div className="mx-auto max-w-7xl px-0 py-24 sm:py-32 lg:flex lg:items-center lg:gap-x-6 xl:gap-x-10 lg:px-8 lg:py-40">
        <div className="mx-auto lg:max-w-lg xl:max-w-xl lg:mx-0 lg:flex-auto">
          <div className="flex">
            <div className="relative flex items-center gap-x-4 rounded-full bg-halfmast-1000 px-4 py-1 text-sm/6 text-muted-foreground ring-1 ring-gray-900/10 hover:ring-gray-900/20">
              <span className="font-semibold text-primary">What&#39;s new</span>
              <span aria-hidden="true" className="h-4 w-px bg-halfmast-800" />
              <a
                href="https://github.com/flagsync/cli"
                className="flex items-center gap-x-1"
              >
                <span aria-hidden="true" className="absolute inset-0" />
                Just shipped FlagSync CLI
                <ChevronRightIcon
                  aria-hidden="true"
                  className="-mr-2 size-5 text-halfmast-800"
                />
              </a>
            </div>
          </div>
          <h1 className="mt-10 text-5xl font-black tracking-tight text-pretty sm:text-7xl max-w-[10ch]">
            Ship fast, break{' '}
            <span className="text-primary italic relative">nothing</span>
          </h1>
          <p className="mt-8 text-lg font-medium text-pretty text-muted-foreground sm:text-xl/8">
            Type-safe feature flags and dead-simple experiments.
          </p>
          <div className="mt-10 flex flex-col md:flex-row items-center gap-y-2 md:gap-x-6">
            <Button
              asChild
              size="lg"
              variant="glowing"
              className="uppercase w-full md:w-fit flex-shrink-0"
            >
              <Link to="/register">Try FlagSync for Free</Link>
            </Button>

            <Button
              asChild
              variant="link"
              className="uppercase w-full md:w-fit flex-shrink-0"
            >
              <a
                href="https://docs.flagsync.com"
                className="inline-flex items-center"
              >
                View Docs
                <ArrowRight className="ml-2 w-4 h-4" />
              </a>
            </Button>
          </div>
          <TypographyMuted className="inline-flex items-center gap-2 mt-6 justify-center md:justify-start w-full md:w-fit">
            <Shield className="size-4" />
            <span>No credit card required • Free 14-day trial</span>
          </TypographyMuted>
        </div>
        <div className="mt-16 sm:mt-24 lg:mt-0 lg:shrink-0 lg:grow">
          <FeatureCarousel />
        </div>
      </div>
    </section>
  );
}
